import * as _ from "lodash";
import * as moment from "moment";
import createGraph from "ngraph.graph";
import PoNode from "./po-node";
import { ProductionShopFloorWorkOrders } from "src/app/services/service/DataProviders/ProductionShopFloorWorkOrders";

export class PoTree {
  private woService: ProductionShopFloorWorkOrders;
  public tree;
  public maxLevel = 0;
  public po = null;

  constructor(woService) {
    this.tree = createGraph();
    this.woService = woService;
  }

  public async init(po) {
    this.po = po;
    await this.buildTree(po, 0);
    await this.getMaxLevel();
  }

  public async buildTree(po, level = 0) {
    
    let masterNode = new PoNode(
      po,
      level,
      this.woService,
      this,
    );

    let masterNodeRes = await masterNode.init();
    if (masterNodeRes === false) {
      return null;
    }
    this.tree.addNode(masterNode);
    let children = masterNode.children;

    for (let i = 0; i < children.length; i++) {
      let childNode = await this.buildTree(
        children[i],
        level + 1,
      );

      if (_.isNull(childNode)) {
        continue;
      }

      this.tree.addNode(childNode);
      this.tree.addLink(masterNode, childNode);
    }

    return masterNode;
  }

  public async getMaxLevel() {
    let self = this;
    self.tree.forEachNode(function (node) {
      if (node.id.level > self.maxLevel) {
        self.maxLevel = node.id.level;
      }
    });

    return self.maxLevel;
  }

  public getLinkedNodes(node) {
    let nodes = [];
    this.tree.forEachLinkedNode(node, function(linkedNode, link){
      nodes.push(linkedNode.id);
    });

    return nodes;
  }

  public getNodesOnLevel(level) {
    let nodes = [];
    this.tree.forEachNode(function (node) {
      // console.log(node.id.level, level);
      if (node.id.level == level) {
        nodes.push(node.id);
      }
    });
    return nodes;
  }

  public getSuccessors(node) {
    let nodes = [];
    this.tree.forEachLinkedNode(node, function(linkedNode, link){
      if(node.level < linkedNode.id.level) {
        nodes.push(linkedNode.id);
      }
    });
    return nodes;
  }

  public getPredecessor(node) {
    let nodes = [];
    this.tree.forEachLinkedNode(node, function(linkedNode, link){
      if(node.level > linkedNode.id.level) {
        nodes.push(linkedNode.id);
      }
    });
    return nodes;
  }

  public getDocumentNo() {
    let nodesWithLevel0 = this.getNodesOnLevel(0);
    let master = nodesWithLevel0[0];
    return master.getDocumentNo();
  }

  public getAllNodes() {
    let nodes = [];
    this.tree.forEachNode(function (node) {
      nodes.push(node.id);
    });
    return nodes;
  }
}
